var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',{class:_vm.$style.container},[_c('i',{class:[
      ("el-icon-" + _vm.icon),
      _vm.$style.icon ]}),_c('div',{class:_vm.$style.text},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_c('i',{class:[
      'el-icon-close',
      _vm.$style.close ],on:{"click":_vm.onClose}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }